export const enum BUTTON_TYPES_ENUM {
	PRIMARY = 'primary',
	SUCCESS = 'success',
	WARNING = 'warning',
	DANGER = 'danger',
	INFO = 'info',
	TEXT = 'text',
}

export const BUTTON_TYPES = [
	BUTTON_TYPES_ENUM.PRIMARY,
	BUTTON_TYPES_ENUM.SUCCESS,
	BUTTON_TYPES_ENUM.WARNING,
	BUTTON_TYPES_ENUM.DANGER,
	BUTTON_TYPES_ENUM.INFO,
	BUTTON_TYPES_ENUM.TEXT,
];
